const GOOGLE_API = "AIzaSyBzklZrXp0F4FVGpOx4-naoByydpodrv0g" 

export default GOOGLE_API